import Image from 'next/image'
import { Typography } from '@acko/typography'
import PropertyControlledComponent from '@components/PropertyControlledComponent/PropertyControlledComponent'

type ModalDisclaimerProps = {
  text: string
  iconSrc: string
}

export const ModalDisclaimer = ({ text, iconSrc }: ModalDisclaimerProps) => {
  if (!text) return null
  return (
    <div className="abha-hero-modal__disclaimer">
      <PropertyControlledComponent controllerProperty={!!iconSrc} fallback={null}>
        <Image src={iconSrc} alt="" width={20} height={20} className="abha-hero-modal__disclaimer-icon" aria-hidden />
      </PropertyControlledComponent>
      <Typography scale="xs" emphasis="normal" color="secondary" className="abha-hero-modal__disclaimer-text">
        {text}
      </Typography>
    </div>
  )
}
